import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './i18n'
import { initErrorLogging } from './services/logging'

Vue.config.productionTip = false

initErrorLogging() // This way console.errors is available globally and can be used when trying to debug

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')